export default __webpack_public_path__ + "3344f1637728cf7569b65f52eef8f9ca.woff";